import React, { useEffect } from 'react'
import { ActivityProgress, CustomType, GoalWithProgress, ProgressType } from '../../services/api.types'
import YumGoalRankingWrapper from '../../components/YumGoalRanking/YumGoalRankingWrapper'
import YumCustomEntryWrapper from '../../components/YumCustomEntry/YumCustomEntryWrapper'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import YumUserProgressCelebration from '../../components/YumUserProgressCelebration/YumUserProgressCelebration'
import { isNative } from '../../common/helpers/isNative'
import { t } from 'ttag'

export interface IChallengeRankingProps {
  goal?: GoalWithProgress
  userProgress: ActivityProgress
  getCurrentCompanyGoal(): void
}

export default function ChallengeRanking(props: IChallengeRankingProps) {
  const { goal, getCurrentCompanyGoal } = props

  useEffect(() => {
    getCurrentCompanyGoal()
  }, [])

  if (!goal) return <></>

  if (
    !Object.values(ProgressType).includes(goal.progressType) ||
    (goal.customType && !Object.values(CustomType).includes(goal.customType))
  ) {
    return <div className={'text-center'}>{t`Challenge type not supported. Please check for updates.`}</div>
  }

  return (
    <div style={{ paddingBottom: '24px' }}>
      <NotificationsWrapper />

      {isNative() && props.userProgress ? (
        <YumUserProgressCelebration
          activityProgress={props.userProgress}
          progressType={goal.progressType}
          manualEntryEnabled={goal.manualEntryEnabled}
        />
      ) : (
        ''
      )}

      <YumCustomEntryWrapper goal={goal} isNewLayout={true} showManualEntry={true} />
      <YumGoalRankingWrapper goalDto={goal} isNewLayout={true} />
    </div>
  )
}
